module.exports = __webpack_public_path__ + "img/litter-in-bin-sign.e677987a.png";